<template>
  <router-view />
</template>

<script setup>
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
}

#app {
  min-height: 100vh;
}

/* 移动端响应式全局样式 */
@media (max-width: 768px) {
  body {
    font-size: 14px;
  }
  
  /* 触摸反馈优化 */
  button, a, [role="button"] {
    -webkit-tap-highlight-color: transparent;
  }
  
  button:active, a:active, [role="button"]:active {
    opacity: 0.7;
  }
}

@media (max-width: 480px) {
  body {
    font-size: 13px;
  }
}
</style>
